import { Menu, Typography } from 'antd';
import styled from 'styled-components';
import { FC, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Content } from '@/components';
import { NAMESPACE, PRIVATE_PATH } from '@/constants';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

const StyledMenu = styled(Menu)`
  &.ant-menu {
    font-size: 16px;

    .ant-menu-item:not(.ant-menu-item-selected) {
      font-weight: 400;
      color: ${({ theme }) => theme.color.neutral_8};
    }
  }

  &.ant-menu-light.ant-menu-horizontal {
    & > .ant-menu-item-selected {
      color: ${({ theme }) => theme.color.neutral_10};

      &::after {
        border-bottom-color: ${({ theme }) => theme.color.primary_6};
      }
    }

    & > .ant-menu-item:hover::after {
      border-bottom-color: ${({ theme }) => theme.color.primary_6};
    }
  }
`;

const TraderControls: FC = () => {
  const { t } = useTranslation(NAMESPACE.COMMON);
  const { pathname } = useLocation();
  const [current, setCurrent] = useState<string>('channels');

  const menuItems = useMemo(
    () => [
      { key: 'channels', label: t('traderControlsChannels'), path: '/channels' },
      { key: 'dsp-fees', label: t('traderControlsDspFees'), path: '/dsp-fees' },
      { key: 'trading-deals', label: t('traderControlsTradingDeals'), path: '/trading-deals' },
      { key: 'kpis', label: t('traderControlsKpis'), path: '/kpis' }
    ],
    [t]
  );

  useEffect(() => {
    const subRoute = pathname.split('/')[2];
    setCurrent(
      subRoute === 'dsp-fees'
        ? 'dsp-fees'
        : subRoute === 'trading-deals'
          ? 'trading-deals'
          : subRoute === 'kpis'
            ? 'kpis'
            : 'channels'
    );
  }, [pathname]);

  return (
    <Content style={{ paddingTop: 8 }}>
      <Typography.Text strong style={{ display: 'block', marginBottom: 8, fontSize: 14, color: APP_SHELL_THEME.textStrong }}>
        {t('traderControls')}
      </Typography.Text>
      <StyledMenu
        selectedKeys={[current]}
        mode="horizontal"
        className="app-shell-subnav"
        items={menuItems.map(({ key, label, path }) => ({
          key,
          label: <Link to={PRIVATE_PATH.TRADER_CONTROLS + path}>{label}</Link>
        }))}
      />
      <Outlet />
    </Content>
  );
};

export default TraderControls;

